import { ReactComponent as CloseIcon } from 'assets/icons/close-badge-icon.svg';
import { lynch } from 'shared/config/Colors';
import { Badge } from './Badge';

export const NewCollaborationBadge = ({
  onClose,
}: {
  onClose?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}) => {
  return (
    <Badge bgColor={lynch}>
      NEW COLLABORATION{onClose && <CloseIcon onClick={(e) => onClose(e)} />}
    </Badge>
  );
};

NewCollaborationBadge.defaultProps = {
  onClose: undefined,
};
